import { useReadContract, useAccount } from 'wagmi'
import { W2USDT_ADDRESS, BRIDGE_CONTRACT_ADDRESS, UNI2_CHAIN_ID } from '@/constants/addresses'
import { ERC20_ABI } from '@/constants/abis'

export function useTokenAllowance() {
  const { address } = useAccount()

  const { data: allowance, isLoading, refetch } = useReadContract({
    address: W2USDT_ADDRESS,
    abi: ERC20_ABI,
    functionName: 'allowance',
    args: address ? [address, BRIDGE_CONTRACT_ADDRESS] : undefined,
    chainId: UNI2_CHAIN_ID,
    query: {
      enabled: !!address,
    },
  })

  return {
    allowance: allowance as bigint | undefined,
    isLoading,
    refetch,
  }
}
